import React, { useEffect, useState } from 'react';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Container, Grid, Avatar, Link, Button } from '@material-ui/core';

import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import DialogGojs from './DialogGojs';

import ScrollAnimation from 'react-animate-on-scroll';

import structure from './Structure.json';

const useStyles = makeStyles((theme) => ({
    xl: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    subHeader: {
        color: theme.palette.common.white,
        background: theme.palette.secondary.dark,
        paddingLeft: theme.spacing(1),
        marginBottom: theme.spacing(2)
    },
    wrapper: {
        width: 100 + theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(1),
        margin: '8px 0'
    },
    svg: {
        width: 100,
        height: 100,
    },
    polygon: {
        fill: theme.palette.common.white,
        stroke: theme.palette.divider,
        strokeWidth: 1,
    },
    treeItemDir: {
        background: theme.palette.info.main,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2)
    },
    treeItemDirMember: {
        background: theme.palette.info.light,
        margin: theme.spacing(1)
    },
    treeItemSubDirTec: {
        background: theme.palette.warning.dark,
        margin: theme.spacing(1)
    },
    treeItemSubDirAdm: {
        background: theme.palette.success.main,
        margin: theme.spacing(1)
    },
    treeItemGroupAdm: {
        background: theme.palette.success.light,
        margin: theme.spacing(1)
    },
    treeItemGroup: {
        background: theme.palette.warning.main,
        margin: theme.spacing(1)
    },
    treeItemDep: {
        background: theme.palette.warning.light,
        margin: theme.spacing(1)
    },
}));

export default function Structure() {
    const classes = useStyles();
    const [checked, setChecked] = useState(false);
    const [elevation, setElevation] = useState(0);

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = () => {
        setChecked((prev) => !prev);
    };
    useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    const consejoDirComponent = structure.cdir.map((member, index) => (
        <Grid item xs={12} sm={6} container key={index} spacing={1}>
            <Grid item>
                <Avatar alt={member.name} src={member.avatar} className={classes.xl} />
            </Grid>
            <Grid item xs container direction="column" spacing={2}>
                <Grid item xs>
                    <Link href="#" onClick={(event) => event.preventDefault()} variant="subtitle1" underline="none">
                        {member.name}
                    </Link>
                    <Typography variant="body2" gutterBottom color="textSecondary">
                        {member.position}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {member.degree}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    ));
    return (
        <section id="structure">
            <div className="features-bg1">
                <Container>
                    <div className="heading">
                        <Typography variant="h4" className="efecto-espejo">
                            Estructura
                        </Typography>
                    </div>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={4}>
                            <Paper className={classes.paper} elevation={elevation} onMouseOver={() => setElevation(4)} onMouseOut={() => setElevation(0)}>
                                {/* <Avatar alt="Remy Sharp" src="./assets/frontend/onepage2/img/member/member1.png" className={classes.xl} /> */}
                                <TreeView
                                    defaultCollapseIcon={<ExpandMoreIcon />}
                                    defaultExpandIcon={<ChevronRightIcon />}
                                    defaultExpanded={['1', '2', '4', '7', '3']}
                                >
                                    <TreeItem nodeId="1" label="Dirección" className={classes.treeItemDir}>
                                        <TreeItem nodeId="2" label="Sub-dirección Técnica" className={classes.treeItemSubDirTec} >
                                            <TreeItem nodeId="4" label="Grupo Científico" className={classes.treeItemGroup} >
                                                <TreeItem nodeId="8" label="Laboratorio" className={classes.treeItemDep} />
                                            </TreeItem>
                                            <TreeItem nodeId="5" label="Grupo Pronósticos" className={classes.treeItemGroup} />
                                            <TreeItem nodeId="6" label="Grupo Instrumentos" className={classes.treeItemGroup} />
                                            <TreeItem nodeId="7" label="Grupo Informática" className={classes.treeItemGroup} >
                                                <TreeItem nodeId="9" label="Dep Informática" className={classes.treeItemDep} />
                                            </TreeItem>
                                            <TreeItem nodeId="10" label="Estación Contramaestre" className={classes.treeItemGroup} />
                                            <TreeItem nodeId="11" label="Estación Universidad" className={classes.treeItemGroup} />
                                            <TreeItem nodeId="12" label="Estación GP" className={classes.treeItemGroup} />
                                            <TreeItem nodeId="13" label="Estación de Radar GP" className={classes.treeItemGroup} />
                                        </TreeItem>
                                        <TreeItem nodeId="3" label="Sub-dirección Administrativa" className={classes.treeItemSubDirAdm} >
                                            <TreeItem nodeId="14" label="Grupo Gestión Económica" className={classes.treeItemGroupAdm} />
                                            <TreeItem nodeId="15" label="Grupo Gestión de Recurso Humanos" className={classes.treeItemGroupAdm} />
                                            <TreeItem nodeId="16" label="Brigada de Mantenimiento" className={classes.treeItemGroupAdm} />
                                        </TreeItem>
                                        <TreeItem nodeId="17" label="Técnico Protección&Defensa" className={classes.treeItemDirMember} />
                                        <TreeItem nodeId="18" label="Chofer" className={classes.treeItemDirMember} />
                                    </TreeItem>
                                </TreeView>

                                <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                                    Ver Gráfico
                                </Button>
                                <DialogGojs setDialogOpen={open} onDialogClose={handleClose} />
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <Paper elevation={elevation} className={classes.paper} onMouseOver={() => setElevation(4)} onMouseOut={() => setElevation(0)}>
                                <Typography variant="h5" color="textPrimary" className={classes.subHeader}>
                                    Consejo de Dirección
                                </Typography>

                                <Grid container spacing={2}>

                                    {
                                        consejoDirComponent
                                    }
                                    
                                </Grid>

                            </Paper>
                        </Grid>

                    </Grid>


                    <ScrollAnimation animateIn="fadeIn">
                        Probando ScrollAnimation.
                    </ScrollAnimation>

                </Container>
            </div>
        </section>
    );
}